<template>
    <section class="piece-details">
        <header class="heaer-layout">
            <mo-pageheader>
                <template slot="title">Détail de la pièce: <span class="label" v-if="part">pièce manuelle</span></template>
                <template slot="action">
                    <div class="buttons-container flex flex-end">
                        <span class="btn-action primary" @click="handleGoBack" v-if="edition">Retour</span>
                        <a class="btn-action primary" @click="$router.go(-1)" v-else>Retour</a>
                    </div>
                </template>
            </mo-pageheader>
        </header>

        <main class="main-layout">
            <!-- TAB SECTION -->
            <div class="flex flex-center">

            </div>

            <!-- PIECE DETAILS SECTION -->
            <ba-card v-if="activeTab == 'detail'">
                <template slot="header">
                    <span>Informations générales</span>
                </template>
                <template>
                    <div class="cols">
                        <div class="col-4">
                            <!--              <ba-input type="text" label="Type de pièce" v-model="part_type" ></ba-input>-->
                            <ba-select class="mandatory" label="Type de pièce"   v-model="part_type">
                                <option :value="type.id" v-for="(type, index) in types" :key="`type_${index}`">{{ type.name }}</option>
                            </ba-select>
                            <ba-input type="text" label="Marque" v-model="brand" :disabled="(selectedBrand != null)" class="input" @input="handleSearchMarque()" ></ba-input>
                            <div v-if="(selectedBrand != null)" style="position: absolute;margin-top: -41px;margin-left: calc(25% - 50px);cursor: pointer;" @click="deleteMarque()">X</div>
                            <div v-if="(brand.length > 0) && (selectedBrand == null)" class="dropdown-part" style="width:25%;margin-top:-20px;">
                                <ul v-if="listFilterBrand.length" class="dropdown-part-u">
                                    <li
                                        v-for="(item, index) in listFilterBrand"
                                        :key="index"
                                        class="dropdown-part-li"
                                        @click="selectBrand(item)"
                                        >
                                        {{ item.name }}
                                    </li>
                                </ul>
                                <ul class="dropdown-part-u">
                                    <li class="dropdown-part-li" @click="createBrand()" >
                                        {{ brand }} (créer)
                                    </li>
                                </ul>
                            </div>
                            <!--              <ba-input type="text" label="Centre" v-model="company" ></ba-input>-->
                            <ba-select class="mandatory" label="Centre"   v-model="company">
                                <option :value="type.id" v-for="(type, index) in companyList" :key="`type_${index}`">{{ type.name }}</option>
                            </ba-select>
                            <ba-input type="text" label="Immatriculation" v-model="matriculation" @keypress="handleCheckMatriculation($event)"  @input="handleCheckMatriculationInput()" ></ba-input>
                            <ba-input type="text" label="Carrosserie" v-model="carbody" @keypress="handleCheckCarbody($event)" @input="handleCheckCarbodyInput()" ></ba-input>
                        </div>
                        <div class="col-4">
                            <ba-input type="text" label="Type transmission" v-model="transmission_type" @keypress="handleCheckTransmissionType($event)" @input="handleCheckTransmissionTypeInput()" ></ba-input>
                            <ba-input type="text" label="Modèle" v-model="model" :disabled="(selectedModel != null || selectedBrand == null)" class="input" @input="handleSearchModel()" ></ba-input>
                            <div v-if="(selectedModel != null)" style="position: absolute;margin-top: -41px;margin-left: calc(25% - 50px);cursor: pointer;" @click="deleteModel()">X</div>
                            <div v-if="(model.length > 0) && (selectedModel == null)" class="dropdown-part" style="width:25%;margin-top:-20px;">
                                <ul v-if="listFilterModel.length" class="dropdown-part-u">
                                    <li
                                        v-for="(item, index) in listFilterModel"
                                        :key="index"
                                        class="dropdown-part-li"
                                        @click="selectModel(item)"
                                        >
                                        {{ item.name }}
                                    </li>
                                </ul>
                                <ul class="dropdown-part-u">
                                    <li class="dropdown-part-li" @click="createModel()" >
                                        {{ model }} (créer)
                                    </li>
                                </ul>
                            </div>
                            <ba-input type="text" label="Sku" v-model="sku" :disabled="true"  @keypress="handleChecksku($event)" @input="handleCheckskuInput()"></ba-input>
                            <ba-input class="mandatory" type="text" label="Emplacement / Casier" v-model="location"  @keypress="handleChecklocation($event)" @input="handleChecklocationInput()"></ba-input>
                            <ba-input type="text" label="Cylindré" v-model="cylindre" @keypress="handleCheckcylindre($event)" @input="handleCheckcylindreInput()"></ba-input>
                        </div>
                        <div class="col-4">

                            <div v-if="accessRestreintSku === 1" class="div-accessrestreint">
                                <span class="btn-action primary btn-accessrestreint"  @click="clickBtnAccessReistreint()">Type {{part_type == 1 ? 'moteur' : 'boite'}}</span>
                            </div>
                            <ba-input type="text" class="mandatory" label="Type moteur" v-model="motor" v-if="(part_type == 1)" @keypress="handleCheckmotor($event)" @input="handleCheckmotorInput()" ></ba-input>
                            <ba-input type="text" class="mandatory" label="Type boîte" v-model="gearbox" v-else="(part_type == 2)" @keypress="handleCheckgearbox($event)" @input="handleCheckgearboxInput()" ></ba-input>			  

                            <ba-input type="text" label="Génération" v-model="generation" :disabled="(selectedGeneration != null || selectedModel == null)" class="input" @input="handleSearchGeneration()" ></ba-input>
                            <div v-if="(selectedGeneration != null)" style="position: absolute;margin-top: -41px;margin-left: calc(25% - 50px);cursor: pointer;" @click="deleteGeneration()">X</div>
                            <div v-if="(generation.length > 0) && (selectedGeneration == null)" class="dropdown-part" style="width:25%;margin-top:-20px;">
                                <ul v-if="listFilterGeneration.length" class="dropdown-part-u">
                                    <li
                                        v-for="(item, index) in listFilterGeneration"
                                        :key="index"
                                        class="dropdown-part-li"
                                        @click="selectGeneration(item)"
                                        >
                                        {{ item.name }}
                                    </li>
                                </ul>
                                <ul class="dropdown-part-u">
                                    <li class="dropdown-part-li" @click="createGeneration()" >
                                        {{ generation }} (créer)
                                    </li>
                                </ul>
                            </div>
                            <ba-input type="text" class="mandatory" label="Prix d’achat" v-model="price" @keypress="handleCheckPrice($event)" @input="handleCheckPriceInput()" ></ba-input>
                            <ba-input type="text" class="mandatory" label="Id stock" v-model="stock_id" @keypress="handleCheckstockid($event)" @input="handleCheckstockidInput()" ></ba-input>
                            <ba-input type="text" label="Nombre vitesse" v-model="gear_nb" @keypress="handleCheckGearNb($event)" @input="handleCheckGearNbInput()" ></ba-input>
                        </div>
                        <div class="col-4">
                            <ba-input type="text" label="Code moteur" v-model="motor_code" v-if="part_type == 1" @keypress="handleCheckmotorcode($event)" @input="handleCheckmotorcodeInput()"></ba-input>
                            <ba-input type="text" label="Code boîte" v-model="gearbox_code" v-else="part_type == 2" @keypress="handleCheckgearboxcode($event)" @input="handleCheckgearboxcodeInput()" ></ba-input>
                            <ba-input type="text" label="Version" v-model="version"  :disabled="(selectedVersion != null || selectedGeneration == null)" class="input" @input="handleSearchVersion()"></ba-input>
                            <div v-if="(selectedVersion != null)" style="position: absolute;margin-top: -41px;margin-left: calc(25% - 50px);cursor: pointer;" @click="deleteVersion()">X</div>
                            <div v-if="(version.length > 0) && (selectedVersion == null)" class="dropdown-part" style="width:25%;margin-top:-20px;">
                                <ul  v-if="listFilterVersion.length" class="dropdown-part-u">
                                    <li
                                        v-for="(item, index) in listFilterVersion"
                                        :key="index"
                                        class="dropdown-part-li"
                                        @click="selectVersion(item)"
                                        >
                                        {{ item.name }}
                                    </li>
                                </ul>
                                <ul class="dropdown-part-u">
                                    <li class="dropdown-part-li" @click="createVersion()" >
                                        {{ version }} (créer)
                                    </li>
                                </ul>
                            </div>
                            <ba-input type="text" label="Kilométrage" v-model="km" @keypress="handleCheckKm($event)" @input="handleCheckKmInput()"></ba-input>
                            <ba-input type="text" label="CIVS" v-model="policy" @keypress="handleCheckpolicy($event)" @input="handleCheckpolicyInput()"></ba-input>
                            <!--              <ba-input type="text" label="Date mise en circulation" v-model="circulation" ></ba-input>-->
                            <div class="basic-date">
                                <label>Date mise en circulation</label>
                                <datepicker
                                    id="start_deb"
                                    v-model="circulation"
                                    name="start_deb"
                                    class="basic-datepicker"
                                    format="dd/MM/yyyy"
                                    :highlighted="highlighted"
                                    :monday-first="true"
                                    :language="fr"
                                    :disabled-dates="{}"
                                    />
                                <ab-icon
                                    icon="calendar"
                                    iconset="calendarSet"
                                    />
                            </div>
                        </div>
                    </div>
                    <ba-textarea label="Description de la pièce" :rows="8" v-model="description" ></ba-textarea>
                    <div class="checkbox-container flex flex-center">
                        <ba-checkbox v-model="appraised" >Pièce expertisée</ba-checkbox>
                        <ba-checkbox class="checkbox-margin" v-model="cleared" >Pièce dépolluée</ba-checkbox>
                        <ba-checkbox v-model="dismounted" >Pièce démontée</ba-checkbox>
                    </div>
                    <span v-if="part.Image && part.Image.length > 0" class="bar"></span>
                    <span v-else ><br/></span>
                    <ba-button v-if='edition && accessAddPicture' type="button" class="primary" @click.native="handleAddDocumentImg">Ajouter une image</ba-button>

                    <div v-if="part.Image && part.Image.length > 0" class="carousel-container" :class="part.Image && part.Image.length < slideNumber ? 'carousel-center' : ''">
                        <tiny-slider
                            ref="tinyslider"
                            v-if="part.Image && part.Image.length"
                            :center="false"
                            :loop="true"
                            :lazyload="true"
                            :items="slideNumber"
                            :controls="isControllable"
                            :controls-container="isControllable ? '.custom-pagination' : ''"
                            :prev-button="isControllable ? '.prev' : ''"
                            :next-button="isControllable ? '.next' : ''"
                            :rewind="true"
                            :nav="false"
                            >
                            <!-- FIXME : Dev purpose -->
                            <div class="img-ctn tns-item" v-for="(image, index) in part.Image" :key="index">
                                <img class="carousel-img carousel_loupe"
                                     :class="part.Image && part.Image.length >= slideNumber ? 'tns-lazy-img' : ''"
                                     :src="`${getImage(image.minify_path, part.Company.id, index)}`"
                                     :data-src="`${getImage(image.minify_path, part.Company.id, index)}`"
                                     @error="defaultImagePath" @click="ClickImgCarroussel(index)">
                            </div>
                        </tiny-slider>
                        <div class="custom-pagination" id="carousel_0" v-if="isControllable">
                            <button class="prev flex flex-center"><ab-icon icon="left"></ab-icon></button>
                            <button class="next flex flex-center"><ab-icon icon="right"></ab-icon></button>
                        </div>
                    </div>
                </template>
            </ba-card>

            <!-- DOCUMENT REPORT MODAL -->
            <modal ref="pimg2" class="modal" name="modal-image" :height="'auto'"   :shiftX="0"  :shiftY="0" :width="widthscreen">
                <ba-card>
                    <template slot="header">
                        <span>{{ this.brand }} - {{ this.model }}</span>
                    </template>      

                    <template>
                        <div  class="carousel-container carousel-container2" :class="part.Image && part.Image.length < slideNumber ? 'carousel-center' : ''" >
                            <tiny-slider style="width: 100% !important;height: 100% !important;"
                                         ref="tinyslider"
                                         v-if="part.Image && part.Image.length"
                                         :center="false"
                                         :loop="true"
                                         :lazyload="true"
                                         :items="slideNumber"
                                         :controls="isControllableModal"
                                         :controls-container="isControllableModal ? '.custom-paginationm' : ''"
                                         :prev-button="isControllableModal ? '.prevm' : ''"
                                         :next-button="isControllableModal ? '.nextm' : ''"
                                         :rewind="true"
                                         :nav="false"
                                         >

                                <div class="img-ctnmodal tns-item">
                                    <img ref="imgr2" class="carousel-img imgZoom" :style="stylePreview"
                                         :src="`${getImage(this.imgCarrousselPath, this.imgCarrousselCompanyId, this.imgCarrousselIndex)}`"
                                         :data-src="`${getImage(this.imgCarrousselPath, this.imgCarrousselCompanyId, this.imgCarrousselIndex)}`"
                                         @error="defaultImagePath"
                                         @load="recenterModal2">
                                </div>

                            </tiny-slider>
                            <div class="custom-pagination custom-paginationm" v-if="isControllableModal">
                                <button class="prevm flex flex-center" @click="prevCarrousselModal()"><ab-icon icon="left"></ab-icon></button>
                                <button class="nextm flex flex-center" @click="nextCarrousselModal()"><ab-icon icon="right"></ab-icon></button>
                            </div>
                        </div>
                    </template>

                    <template slot="footer">
                        <div class="buttons-container flex flex-end">
                            <ba-button v-if="accessDeletePicture" type="button" class="danger" @click.native="deleteImg">Supprimer</ba-button>
                            <ba-button type="button" class="primary" @click.native="$modal.hide('modal-image')">Fermer</ba-button>
                        </div>
                    </template>
                </ba-card>
            </modal>    

        </main>

        <footer class="footer-layout">
            <div class="buttons-container flex flex-end">
                <ba-button v-if="accessDeletePart && edition" type="button" class="danger" @click.native="openDeletePart">Supprimer</ba-button>
                <span class="btn-action primary" style="margin-left:10px;margin-right: 10px" @click="handleGoBack" v-if="edition">Retour</span>
                <a class="btn-action primary" style="margin-left:10px;margin-right: 10px" @click="$router.go(-1)" v-else>Retour</a>
                <span class="btn-action primary" @click="handleGoSave2" >Sauvegarder</span>
            </div>
        </footer>

        <!-- img/Motor/Gearbox ADD -->
        <modal class="modal" name="add-img" width="376px" >
            <ba-card>
                <template slot="header">
                    <span>{{ $t('sectionTitle.addImg') }} </span>
                </template>

                <template >

                    <form @submit.prevent="handleAddImgFa" enctype="multipart/form-data">

                        <file-pond
                            name="test"
                            ref="pond"
                            :label-idle="attachedFile.pondLabel"
                            :allow-multiple="false"
                            :max-file-size="attachedFile.maxFileSizeTrunc"
                            :label-file-type-not-allowed="'Fichier invalide'"
                            :file-validate-type-label-expected-types="''"
                            :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                            :label-max-file-size="`La taille d'un fichier doit être de ${attachedFile.maxFileSizeTrunc} maximum`"
                            :allow-file-type-validation="true"
                            :accepted-file-types="attachedFile.pondAcceptedFileType">
                        </file-pond>
                        <div class="buttons-container flex flex-end">
                            <ba-button type="button" class="primary" @click.native="closeModalAddImg">{{ $t('action.cancel') }}</ba-button>
                            <ba-button class="primary" :disabled="isFileImg">{{ $t('action.save') }}</ba-button>
                        </div>
                    </form>

                </template>
            </ba-card>
        </modal>

        <!-- img/Motor/Gearbox PREVIEW -->
        <modal ref="pimg" class="modal"  :height="'auto'"   :shiftX="0"  :shiftY="0" :width="widthscreen"  name="preview-img"  >
            <ba-card>
                <template slot="header">
                    <span>{{ previewLabel }} </span>
                </template>
                <template>
                    <img ref="imgr" :style="stylePreview"  :src="imgSelected" @load="recenterModal" />
                </template>
                <template slot="footer">
                    <div class="buttons-container flex flex-end">
                        <ba-button class="primary" @click.native="closeModalImgPreview">{{ $t('action.close') }}</ba-button>
                    </div>
                </template>
            </ba-card>
        </modal>

        <!-- img/Motor/Gearbox DELETION -->
        <modal class="modal" name="remove-img" width="376px"  @before-open="beforeOpenImg">
            <ba-card>
                <template slot="header">
                    <span>{{ $t('sectionTitle.removeImgFa') }} </span>
                </template>
                <template>
                    <p>{{ $t('modal.removeImgFa') }} : {{removeModalImg.label }}</p>
                </template>
                <template slot="footer">
                    <div class="buttons-container flex flex-end">
                        <ba-button class="primary" @click.native="closeModalImg">{{ $t('action.cancel') }}</ba-button>
                        <ba-button class="danger" @click.native="handleRemoveImgFa">{{ $t('action.confirm') }}</ba-button>
                    </div>
                </template>
            </ba-card>
        </modal>

        <modal class="modal" name="remove-part" width="376px"  @before-open="beforeOpenPart">
            <ba-card>
                <template slot="header">
                    <span>{{ $t('sectionTitle.deletePart') }} </span>
                </template>
                <template>
                    <p>{{ $t('modal.deletePart') }} : {{sku }}</p>
                </template>
                <template slot="footer">
                    <div class="buttons-container flex flex-end">
                        <ba-button class="primary" @click.native="closeModalPart">{{ $t('action.cancel') }}</ba-button>
                        <ba-button class="danger" @click.native="handleRemovePart">{{ $t('action.confirm') }}</ba-button>
                    </div>
                </template>
            </ba-card>
        </modal>
    </section>

</template>

<script>
    import { AbIcon, BaButton, BaCard, BaCheckbox, BaDropdown, BaInput, BaSelect, BaTable, BaTextarea } from '@ab/basic-components';
    import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
    import sortableMixin from '@/components/mixins/sortable.js';
    import { generateSearchWatcher } from '@/assets/js/helpers.js';
    import VueTinySlider from 'vue-tiny-slider';
    import { mapState } from 'vuex';

    import Datepicker from 'vuejs-datepicker';
    import { fr } from 'vuejs-datepicker/dist/locale';

    import vueFilePond from 'vue-filepond';
    import 'filepond/dist/filepond.min.css';
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

    const FilePond = vueFilePond(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);


    export default {
        name: 'PieceCreate',
        components: {
            AbIcon,
            BaButton,
            BaCard,
            BaCheckbox,
            BaDropdown,
            BaInput,
            BaSelect,
            Datepicker,
            BaTable,
            BaTextarea,
            MoPageheader,
            FilePond,
            'tiny-slider': VueTinySlider
        },
        props: {
            skuProp: String,
        },
        mixins: [sortableMixin],
        async mounted() {
            
            await this.initMounted()



        },
        data() {
            return {
                accessAddPicture: false,
                accessDeletePicture: false,
                accessDeletePart: false,
                edition: false,
                imgCarrousselPath: '',
                imgCarrousselCompanyId: '',
                imgCarrousselIndex: '',
                imgCarrousselId: '',
                selectedPiece: this.skuProp,
                appraised: false,
                brand: '',
                selectedBrand: null,
                listFilterBrand: [],
                selectedModel: null,
                listFilterModel: [],
                selectedGeneration: null,
                listFilterGeneration: [],
                selectedVersion: null,
                listFilterVersion: [],
                types: null,
                companyList: null,
                carbody: '',
                circulation: '',
                cleared: false,
                company: '',
                cylindre: '',
                description: '',
                dismounted: false,
                gear_nb: '',
                gearbox: '',
                gearbox_code: '',
                generation: '',
                km: '',
                location: '',
                matriculation: '',
                model: '',
                motor: '',
                motor_code: '',
                part_type: '',
                policy: '',
                price: '',
                sku: '',
                stock_id: '',
                transmission_type: '',
                version: '',
                activeTab: 'detail',
                slideNumber: 3,
                path: `${process.env.VUE_APP_ROOT_API}/upload/part/default.png`,
                accessRestreintSku: '',
                infoCreatePart: null,
                widthscreen: 1000,
                isFileImg: false,
                fr,
                imgSelected: '',
                stylePreview: "maxWidth:100%",
                previewLabel: '',
                highlighted: {
                    dates: [
                        new Date()
                    ]
                },
                cols: [
                    {label: '', sortable: false, sorted: '', key: '', class: ''},
                    {label: 'Véhicule', sortable: true, sorted: '', key: 'aaa_brand', class: ''},
                    {label: 'Type moteur', sortable: true, sorted: '', key: 'motor_adaptability', class: ''},
                    {label: 'Type boîte', sortable: true, sorted: '', key: 'gearbox_adaptability', class: ''},
                    {label: 'Puissance Ch.', sortable: true, sorted: '', key: 'aaa_steam_power', class: 'right'},
                    {label: 'Puissance Fis.', sortable: true, sorted: '', key: 'aaa_fiscal_power', class: 'right'},
                    {label: 'Boîte de vitesses', sortable: true, sorted: '', key: 'aaa_gearbox', class: ''},
                    {label: '', sortable: false, sorted: '', key: '', class: ''},
                ],
                attachedFile: {
                    fileId: null,
                    fileStatus: '',
                    maxFileSize: 10000000,
                    maxFileSizeTrunc: '10 MB',
                    pondLabel: "Glissez votre image ou <u>cliquez ici</u>",
                    pondAcceptedFileType: ['image/png', 'image/jpeg'],
                    currentPage: 1,
                    searchLimit: 5
                },
                removeModalImg: {
                    label: '',
                    id: ''
                },
            }
        },
        computed: {
            ...mapState({documents: state => state.parts.documents}),
            ...mapState({part: state => state.parts.part}),
            computedCenter() {
                if (this.part && this.part.Image && this.part.Image.length >= this.slideNumber) {
                    return true;
                }
                return false;
            },
            startIndex() {
                if (this.part && this.part.Image && this.part.Image.length >= this.slideNumber) {
                    return 1;
                }
                return 0;
            },
            isControllable() {
                if (this.part.Image && this.part.Image.length > this.slideNumber) {
                    return true;
                }
                return false;
            },
            isControllableModal() {
                if (this.part.Image && this.part.Image.length > 1) {
                    return true;
                }
                return false;
            }
        },
        methods: {
            async initMounted() {
             
                this.$store.commit('setSpinner', true);
                
                this.widthscreen = window.innerWidth - 50;
                this.$refs.pimg2.modal.width = this.widthscreen;
                this.stylePreview = "maxWidth:" + this.widthscreen + "px;maxHeight:" + (window.innerHeight - 150) + "px;";
 
                this.accessAddPicture = await this.$store.dispatch('getAccesRole', {search: 38, role: this.$store.state.authentication.user.Role.id, data: this.$store.state.authentication.user.allDetailRole});
                this.accessDeletePicture = await this.$store.dispatch('getAccesRole', {search: 39, role: this.$store.state.authentication.user.Role.id, data: this.$store.state.authentication.user.allDetailRole});
                this.accessDeletePart = await this.$store.dispatch('getAccesRole', {search: 37, role: this.$store.state.authentication.user.Role.id, data: this.$store.state.authentication.user.allDetailRole});


                this.infoCreatePart = await this.$store.dispatch('getInfoCreate');


                this.types = this.infoCreatePart.parttype;
                this.companyList = this.infoCreatePart.company;

                this.part.Image = [];
                if ((this.$route.params && this.$route.params.sku) || this.selectedPiece || (this.$route.params && this.$route.params.id)) {
                    this.edition = true;
                    this.sku = this.$route.params.sku || this.selectedPiece;
                    await this.$store.dispatch('getPartInfoId', this.$route.params.id);
                    this.accessRestreintSku = await this.$store.dispatch('getAccessRetreint', {typeRch: 'sku', brand: this.brand, model: this.model, sku: this.sku, part_type: this.part_type, motor: this.motor, gearbox: this.gearbox});

                    const data = await this.$store.dispatch('getPartDocuments', this.sku);

                    let idStock = this.part.id

                    let listViewStockItem = JSON.parse(sessionStorage.getItem('listViewStockItem'))
                    if (listViewStockItem !== null) {
                        let flag = 0;
                        listViewStockItem.forEach(function (Item) {
                            if (idStock == Item) {
                                flag = 1
                            }
                        })
                        if (flag == 0) {
                            listViewStockItem.push(idStock)
                            sessionStorage.setItem('listViewStockItem', JSON.stringify(listViewStockItem))
                        }
                    } else {
                        let listViewStockItem = [idStock]
                        sessionStorage.setItem('listViewStockItem', JSON.stringify(listViewStockItem))
                    }

                }
                else {
                   //generation du sku

                  
                   let formattedTimestamp = Date.now().toString()
                   this.sku = "000"+this.$store.getters.getUser.company_id+"-"+formattedTimestamp;
                }

                this.$store.commit('setSpinner', false);
            },
            async deleteImg() {
  
                var tmpImGPart = this.part.Image;

                this.part.Image = [];
                var tmpImg = [];
                for (var i in tmpImGPart) {
                    if (tmpImGPart[i].id != this.imgCarrousselId) {
                        tmpImg.push(tmpImGPart[i]);
                    }
                }
                this.part.Image = tmpImg;
                const data = await this.$store.dispatch('deleteFileImgStock', {
                    id_file: this.imgCarrousselId

                });
                this.$store.dispatch('displaySnackbar', {text: `L'image a bien été supprimée`});

                this.$modal.hide('modal-image');


            },
            async handleAddImgFa() {
           
if(!this.isFileImg ) {
                // Check if file has been selected
                if (!this.$refs.pond.getFile()) {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un document`, mode: 'error'});
                }

                // Check file size
                if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un document dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error'});
                }

                // Check file type
                const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
                if (typeof fileType == 'undefined') {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez sélectionner document valide`, mode: 'error'});
                }

                var tmpImGPart = this.part.Image;

                this.part.Image = [];

                let file = this.$refs.pond.getFile().file;
                let formData = new FormData();
                formData.append('fileUpload', file, file.name);



                // Prevent from clicking on button during operation
                this.isFileImg = true;
                const data = await this.$store.dispatch('uploadFileImgStock', {
                    part_id: this.part.id,
                    company_id: this.company,
                    sku: this.part.sku,
                    data: formData,
                });
 
                if (data && data.id) {

                    this.$store.dispatch('displaySnackbar', {text: `Le document a bien été ajouté`});
                    var tmpImg = [];
                    for (var i in tmpImGPart) {
                        tmpImg.push(tmpImGPart[i]);
                    }
                    tmpImg.push(data);


                    this.part.Image = tmpImg;
  
                }
                this.$refs.pond.removeFile();
                this.isFileImg = false;


                this.$modal.hide('add-img');
                this.label_img = '';
                }

            },
            closeModalAddImg() {
                this.$modal.hide('add-img');
            },
            handleAddDocumentImg() {
                this.addImgModal = '1';
                this.isFileImg = false;
                this.$modal.show('add-img');
            },
            openDeletePart() {
                this.$modal.show('remove-part');
            },
            beforeOpenPart() {

            },
            closeModalPart() {
                this.$modal.hide('remove-part');
            },
            async handleRemovePart() {
                var data = await this.$store.dispatch('deletePart', {id: this.part.id});
                if (data.error != null) {
                    this.$modal.hide('remove-part');
                    this.$store.dispatch('displaySnackbar', {text: `La pièce est associée à un dossier.`, mode: 'error'});
                } else {
                    this.$store.dispatch('displaySnackbar', {text: `La pièce a été supprimée.`});
                    this.$router.push({name: 'StockList', params: {}});
                }


            },
            recenterModal() {
                this.$refs.pimg.shift.left = 0.5;
                if (this.$refs.imgr.clientWidth < this.widthscreen) {
                    this.$refs.pimg.modal.width = this.$refs.imgr.clientWidth;
                } else {
                    this.$refs.pimg.modal.width = this.widthscreen;
                }
            },
            recenterModal2() {
 
                this.$refs.pimg2.shift.left = 0.5;

                if (this.$refs.imgr2.naturalWidth < this.widthscreen) {
                    this.$refs.pimg2.modal.width = this.$refs.imgr2.naturalWidth;
                } else {
                    this.$refs.pimg2.modal.width = this.widthscreen;
                }
            },
            beforeOpenImg(e) {
                this.removeModalImg.id = e.params.id;
                this.removeModalImg.type = e.params.type;
                this.removeModalImg.label = e.params.label;
            },
            async handleGoSave2() {
       
                if (!this.edition) {
                    if (this.sku != '' && this.sku != null) {
                        var tmpPart = await this.$store.dispatch('getPartInfoNoEvent', this.sku);

                        if (tmpPart == false) {

                        } else {
                            return this.$store.dispatch('displaySnackbar', {text: `Le sku existe déjà, choisissez un autre sku.`, mode: 'error'});
                        }

                    } else {
                        return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un sku`, mode: 'error'});
                    }
                }

                if (this.part_type == null || this.part_type == '') {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez sélectionner le type de pièce`, mode: 'error'});
                }


                if (this.company == null || this.company == '') {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez sélectionner un centre`, mode: 'error'});
                }
                
                if (this.price == null || this.price == '') {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un prix de vente`, mode: 'error'});
                }
                
                if (this.stock_id == null || this.stock_id == '') {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un id stock`, mode: 'error'});
                }
                
                if (this.location == null || this.location == '') {
                    return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un casier/emplacement`, mode: 'error'});
                }
                
                if(this.part_type == 1) {
                    if (this.motor == null || this.motor == '') {
                        return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un type moteur`, mode: 'error'});
                    }
                }
                else {
                    if (this.gearbox == null || this.gearbox == '') {
                        return this.$store.dispatch('displaySnackbar', {text: `Veuillez ajouter un type boîte`, mode: 'error'});
                    }
                }


                if(this.gear_nb != null && this.gear_nb == '') {
                    this.gear_nb = 0;
                } 

                const dataPart = await this.$store.dispatch('createPartStock', {
                    edit: this.edition,
                    part_type: this.part_type,
                    brand: this.brand,
                    company: this.company,
                    matriculation: this.matriculation,
                    carbody: this.carbody,
                    transmission_type: this.transmission_type,
                    model: this.model,
                    sku: this.sku,
                    location: this.location,
                    cylindre: this.cylindre,
                    motor: this.motor,
                    gearbox: this.gearbox,
                    generation: this.generation,
                    price: this.price,
                    stock_id: this.stock_id,
                    gear_nb: this.gear_nb,
                    motor_code: this.motor_code,
                    gearbox_code: this.gearbox_code,
                    version: this.version,
                    km: this.km,
                    policy: this.policy,
                    circulation: this.circulation,
                    description: this.description,
                    appraised: this.appraised,
                    cleared: this.cleared,
                    dismounted: this.dismounted,
                    idPart: this.part.id




                });
                if (dataPart) {
                
                    if (!this.edition) {
                    
                        this.$store.dispatch('displaySnackbar', {text: `La pièce a été sauvegardée`});
                        this.$router.push({name: 'PartCreateEdit', params: {id: dataPart.id, sku: dataPart.sku}});
                        this.initMounted();
                    } else {
                        this.$store.dispatch('displaySnackbar', {text: `La pièce a été mise à jour`});
                    }
                }
            },
            deleteMarque() {
                this.selectedBrand = null;
                this.listFilterBrand = [];
                this.brand = "";
                this.deleteModel();

            },
            async createBrand() {
                var newBrand = {
                    marque: this.brand
                }
                const dataPart = await this.$store.dispatch('createNewBrand', newBrand);
                if (dataPart) {
                    this.selectedBrand = {};
                    this.selectedBrand.id = dataPart;
                    this.selectedBrand.name = this.brand;
                }

            },
            selectBrand(item) {
                this.selectedBrand = item;
                this.brand = item.name;
                this.listFilterBrand = [];
            },
            handleCheckPriceInput() {
                let newPrice = this.price.replace(/[^0-9.]/g, ''); // Supprime caractères invalides

                // Limite à 15 caractères
                if (newPrice.length > 15) {
                    newPrice = newPrice.slice(0, 15);
                }

                // Vérifie si c'est un nombre valide et convertit en float
                if (/^\d+(\.\d*)?$/.test(newPrice)) {
                    newPrice = parseFloat(newPrice);
                }
                this.$nextTick(() => {
                    this.price = newPrice.toString();
                });
            },
            handleCheckPrice($event) {
            
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
     
                const tmp = String(this.price);
        
                if (((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || tmp.indexOf('.') != -1) || (tmp.length > 15))) { // 46 is dot
               
                    $event.preventDefault();
                }

            },
            handleCheckGearNbInput() {
                let newTmp = this.gear_nb.replace(/\D/g, ''); 
                if (newTmp.length > 5) {
                    newTmp = newTmp.slice(0, 5);
                }
                this.$nextTick(() => {
                    this.gear_nb = newTmp.toString();
                });
            },
            handleCheckGearNb($event) {
                console.log("handleCheckGearNb");
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                const tmp = String(this.gear_nb);
                console.log(tmp);
                console.log(keyCode);
                if ((keyCode < 48 || keyCode > 57) || (tmp.length > 5)) { // 46 is dot
                    $event.preventDefault();
                }

            },
             handleCheckKmInput() {
                let newTmp = this.km.replace(/\D/g, ''); 
                if (newTmp.length > 10) {
                    newTmp = newTmp.slice(0, 10);
                }
                this.$nextTick(() => {
                    this.km = newTmp.toString();
                });
            },
            handleCheckKm($event) {
                console.log("handleCheckGearKm");
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                const tmp = String(this.km);
                if ((keyCode < 48 || keyCode > 57) || (tmp.length > 10)) { // 46 is dot
                    $event.preventDefault();
                }

            },
            handleCheckMatriculationInput() {
                let newTmp = this.matriculation;
                if (newTmp.length > 15) {
                    newTmp = newTmp.slice(0, 15);
                }
                this.$nextTick(() => {
                    this.matriculation = newTmp.toString();
                });
            },
            handleCheckMatriculation($event) {
                const tmp = String(this.matriculation);
                if ((tmp.length > 15)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckCarbodyInput() {
                let newTmp = this.carbody;
                if (newTmp.length > 130) {
                    newTmp = newTmp.slice(0, 130);
                }
                this.$nextTick(() => {
                    this.carbody = newTmp.toString();
                });
            },
            handleCheckCarbody($event) {
                const tmp = String(this.carbody);
                if ((tmp.length > 130)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckTransmissionTypeInput() {
                let newTmp = this.transmission_type;
                if (newTmp.length > 130) {
                    newTmp = newTmp.slice(0, 130);
                }
                this.$nextTick(() => {
                    this.transmission_type = newTmp.toString();
                });
            },
            handleCheckTransmissionType($event) {
                const tmp = String(this.transmission_type);
                if ((tmp.length > 130)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckskuInput() {
                let newTmp = this.sku;
                if (newTmp.length > 40) {
                    newTmp = newTmp.slice(0, 40);
                }
                this.$nextTick(() => {
                    this.sku = newTmp.toString();
                });
            },
            handleChecksku($event) {
                const tmp = String(this.sku);
                if ((tmp.length > 40)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleChecklocationInput() {
                let newTmp = this.location;
                if (newTmp.length > 40) {
                    newTmp = newTmp.slice(0, 40);
                }
                this.$nextTick(() => {
                    this.location = newTmp.toString();
                });
            },
            handleChecklocation($event) {
                const tmp = String(this.location);
                if ((tmp.length > 40)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckcylindreInput() {
                let newTmp = this.cylindre;
                if (newTmp.length > 40) {
                    newTmp = newTmp.slice(0, 40);
                }
                this.$nextTick(() => {
                    this.cylindre = newTmp.toString();
                });
            },
            handleCheckcylindre($event) {
                const tmp = String(this.cylindre);
                if ((tmp.length > 40)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckmotorInput() {
                let newTmp = this.motor;
                if (newTmp.length > 130) {
                    newTmp = newTmp.slice(0, 130);
                }
                this.$nextTick(() => {
                    this.motor = newTmp.toString();
                });
            },
            handleCheckmotor($event) {
                const tmp = String(this.motor);
                if ((tmp.length > 130)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckgearboxInput() {
                let newTmp = this.gearbox;
                if (newTmp.length > 130) {
                    newTmp = newTmp.slice(0, 130);
                }
                this.$nextTick(() => {
                    this.gearbox = newTmp.toString();
                });
            },
            handleCheckgearbox($event) {
                const tmp = String(this.gearbox);
                if ((tmp.length > 130)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckstockidInput() {
                let newTmp = this.stock_id;
                if (newTmp.length > 40) {
                    newTmp = newTmp.slice(0, 40);
                }
                this.$nextTick(() => {
                    this.stock_id = newTmp.toString();
                });
            },
            handleCheckstockid($event) {
                const tmp = String(this.stock_id);
                if ((tmp.length > 40)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckmotorcodeInput() {
                let newTmp = this.motor_code;
                if (newTmp.length > 230) {
                    newTmp = newTmp.slice(0, 230);
                }
                this.$nextTick(() => {
                    this.motor_code = newTmp.toString();
                });
            },
            handleCheckmotorcode($event) {
                const tmp = String(this.motor_code);
                if ((tmp.length > 230)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckgearboxcodeInput() {
                let newTmp = this.gearbox_code;
                if (newTmp.length > 230) {
                    newTmp = newTmp.slice(0, 230);
                }
                this.$nextTick(() => {
                    this.gearbox_code = newTmp.toString();
                });
            },
            handleCheckgearboxcode($event) {
                const tmp = String(this.gearbox_code);
                if ((tmp.length > 230)) { // 46 is dot
                    $event.preventDefault();
                }
            },
            handleCheckpolicyInput() {
                let newTmp = this.policy;
                if (newTmp.length > 40) {
                    newTmp = newTmp.slice(0, 40);
                }
                this.$nextTick(() => {
                    this.policy = newTmp.toString();
                });
            },
            handleCheckpolicy($event) {
                const tmp = String(this.policy);
                if ((tmp.length > 40)) { // 46 is dot
                    $event.preventDefault();
                }
            },

            handleSearchMarque() {
                var tmpSearch = this.brand;
                var tmpMarque = this.infoCreatePart["brand"];
                if (tmpSearch.length >= 1) {
                    this.listFilterBrand = tmpMarque.filter((item) =>
                        item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                } else {
                    this.listFilterBrand = [];
                }

            },
            deleteModel() {
                this.selectedModel = null;
                this.listFilterModel = [];
                this.model = "";
                this.deleteGeneration();

            },
            async createModel() {
                var newModel = {
                    marque: this.brand,
                    model: this.model
                }
                const dataPart = await this.$store.dispatch('createNewModel', newModel);
                if (dataPart) {
                    this.selectedModel = {};
                    this.selectedModel.id = dataPart;
                    this.selectedModel.name = this.model;
                    this.selectedModel.brand_id = this.selectedBrand.id;
                }

            },
            selectModel(item) {
                this.selectedModel = item;
                this.model = item.name;
                this.listFilterModel = [];
            },
            handleSearchModel() {
                var tmpSearch = this.model;
                var tmp = this.infoCreatePart["model"];
                var tmpbrand = null;
                if (this.selectedBrand != null) {
                    tmpbrand = this.selectedBrand.id;
                }
                if (tmpSearch.length >= 1) {
                    if (tmpbrand != null) {
                        this.listFilterModel = tmp.filter((item) =>
                            item.brand_id === tmpbrand &&
                                    item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                    } else {
                        this.listFilterModel = tmp.filter((item) =>
                            item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                    }
                } else {
                    this.listFilterModel = [];
                }

            },
            deleteGeneration() {
                this.selectedGeneration = null;
                this.listFilterGeneration = [];
                this.generation = "";
                this.deleteVersion();
            },
            async createGeneration() {
                var newGeneration = {
                    marque: this.brand,
                    model: this.model,
                    generation: this.generation
                }
                const dataPart = await this.$store.dispatch('createNewGeneration', newGeneration);
                if (dataPart) {
                    this.selectedGeneration = {};
                    this.selectedGeneration.id = dataPart;
                    this.selectedGeneration.name = this.generation;
                    this.selectedGeneration.model_id = this.selectedModel.id;
                }

            },
            selectGeneration(item) {
                this.selectedGeneration = item;
                this.generation = item.name;
                this.listFilterGeneration = [];
            },
            handleSearchGeneration() {
                var tmpSearch = this.generation;
                var tmp = this.infoCreatePart["generation"];
                var tmpgeneration = null;
                if (this.selectedModel != null) {
                    tmpgeneration = this.selectedModel.id;
                }
                if (tmpSearch.length >= 1) {
                    if (tmpgeneration != null) {
                        this.listFilterGeneration = tmp.filter((item) =>
                            item.model_id === tmpgeneration &&
                                    item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                    } else {
                        this.listFilterGeneration = tmp.filter((item) =>
                            item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                    }
                } else {
                    this.listFilterGeneration = [];
                }

            },
            deleteVersion() {
                this.selectedVersion = null;
                this.listFilterVersion = [];
                this.version = "";
            },
            async createVersion() {
                var newVersion = {
                    marque: this.brand,
                    model: this.model,
                    generation: this.generation,
                    version: this.version
                }
                const dataPart = await this.$store.dispatch('createNewVersion', newVersion);
                if (dataPart) {
                    this.selectedVersion = {};
                    this.selectedVersion.id = dataPart;
                    this.selectedVersion.name = this.generation;
                    this.selectedVersion.generation_id = this.selectedGeneration.id;
                }

            },
            selectVersion(item) {
                this.selectedVersion = item;
                this.version = item.name;
                this.listFilterVersion = [];
            },
            handleSearchVersion() {
                var tmpSearch = this.version;
                var tmp = this.infoCreatePart["version"];
                var tmpversion = null;
                if (this.selectedGeneration != null) {
                    tmpversion = this.selectedGeneration.id;
                }
                if (tmpSearch.length >= 1) {
                    if (tmpversion != null) {
                        this.listFilterVersion = tmp.filter((item) =>
                            item.model_id === tmpversion &&
                                    item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                    } else {
                        this.listFilterVersion = tmp.filter((item) =>
                            item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                    }
                } else {
                    this.listFilterVersion = [];
                }

            },
            clickBtnAccessReistreint() {
                this.accessRestreintSku = 0
                this.$store.dispatch('setHistoAccess', {typeRch: 'sku', brand: this.brand, model: this.model, sku: this.sku, part_type: this.part_type, motor: this.motor, gearbox: this.gearbox});
            },
            ClickImgCarroussel(imgIndex) {
                this.imgCarrousselIndex = imgIndex
                for (var i = 0; i < this.part.Image.length; i++) {
                    if (i == imgIndex) {
                        this.imgCarrousselPath = this.part.Image[imgIndex].path
                        this.imgCarrousselId = this.part.Image[imgIndex].id
                        this.imgCarrousselCompanyId = this.part.Company.id
                    }
                }
                this.$modal.show('modal-image');
            },
            prevCarrousselModal() {
                if (this.imgCarrousselIndex > 0) {
                    this.imgCarrousselIndex--;
                    for (var i = 0; i < this.part.Image.length; i++) {
                        if (i == this.imgCarrousselIndex) {
                            this.imgCarrousselPath = this.part.Image[i].path
                            this.imgCarrousselId = this.part.Image[i].id
                            this.imgCarrousselCompanyId = this.part.Company.id
                        }
                    }
                } else {
                    this.imgCarrousselIndex = this.part.Image.length - 1;
                    this.imgCarrousselPath = this.part.Image[this.imgCarrousselIndex].path
                    this.imgCarrousselCompanyId = this.part.Company.id
                    this.imgCarrousselId = this.part.Image[this.imgCarrousselIndex].id
                }
            },
            nextCarrousselModal() {
                if (this.imgCarrousselIndex + 1 < this.part.Image.length) {
                    this.imgCarrousselIndex++;
                    for (var i = 0; i < this.part.Image.length; i++) {
                        if (i == this.imgCarrousselIndex) {
                            this.imgCarrousselPath = this.part.Image[i].path
                            this.imgCarrousselId = this.part.Image[i].id
                            this.imgCarrousselCompanyId = this.part.Company.id
                        }
                    }
                } else {
                    this.imgCarrousselIndex = 0;
                    this.imgCarrousselPath = this.part.Image[this.imgCarrousselIndex].path
                    this.imgCarrousselId = this.part.Image[this.imgCarrousselIndex].id
                    this.imgCarrousselCompanyId = this.part.Company.id
                }
            },
            /* -- Modal handling --*/
            handleGoBack() {
                this.$router.push({name: 'StockList', params: {}});
                // this.$emit('close');
            },
            // Get image
            getImage(path, companyId, index) {
                if (path.slice(0, 4) == "http") {
                    return path;
                } else {
                    let baseApi = process.env.VUE_APP_ROOT_API;
                    return `${baseApi}${path}`;
                }
            },
            defaultImagePath(e) {
                // pour les images 'path' on se contente
                // de remplacer par une image vide si existe pas	
                e.target.src = this.path;
            },
            defaultImage(url, index, mode) {
                // pour les images 'minify_path' on se contente
                // on ne prend pas sur le front les images qui n'existent
                // pas pour ne pas casser le carroussel	
                // on vire l'image du store et la vue se recalcule
                // this.$store.dispatch('deleteImgStore', { value: url, index: index });

                document.getElementById('tns1').style.setProperty('width', 'calc(100%)');
            },
            /* Get document motors & gearboxes */
            getTypeAdaptability(adap) {
                const adapArray = (adap && adap.length) ? adap.split(',') : [];
                return adapArray;
            },
            /* Get brand image */
            handleGetBrandImage(brand) {
                let text = brand.split(/[ -]+/)[0].toLowerCase();
                if (text == 'citroën') {
                    text = 'citroen';
                }
                if (text == 'vw') {
                    text = 'volkswagen';
                }
                if (text == 'land') {
                    text = 'rover';
                }
                if (text == 'bedford') {
                    text = 'vauxhall';
                }
                return `https://cdn.activcar.fr/media/64/brands/${text}.png`;
            },
        },
        watch: {
            part(newPart, oldPart) {

                var tmpCirculationyear = '';
                if (newPart.circulation_year != null && newPart.circulation_year != '') {
                    //2025-03-04T09:55:00.000Z
                    //2025-01-31 01:00:00
                    var tmpc = newPart.circulation_year.split(" ");
                    tmpCirculationyear = tmpc[0] + "T01:00:00.000Z";
                }
                this.sku = newPart.sku;
                this.appraised = newPart.appraised;
                this.brand = newPart.Brand.name ? newPart.Brand.name : '';
                this.carbody = newPart.carbody;
                this.circulation = tmpCirculationyear;
                this.cleared = newPart.cleared;
                this.company = newPart.Company.id;
                this.cylindre = newPart.cylindre;
                this.description = newPart.description;
                this.dismounted = newPart.dismounted;
                this.gear_nb = newPart.nb_gears;
                this.gearbox = newPart.gearbox;
                this.gearbox_code = newPart.gearbox_code;
                this.generation = newPart.Generation.name ? newPart.Generation.name : '';
                if(newPart.km != null && newPart.km != '') {
                    this.km = parseInt(newPart.km);
                }
                else {
                    this.km = '';
                }
                this.location = newPart.location;
                this.matriculation = newPart.matriculation;
                this.model = newPart.Model.name ? newPart.Model.name : '';
                this.motor = newPart.motor;
                this.motor_code = newPart.motor_code;
                this.part_type = newPart.Part_type.id;
                this.policy = newPart.policy;
                this.price = parseInt(newPart.price);
                this.stock_id = newPart.stock_id;
                this.transmission_type = newPart.transmission_type;
                this.version = newPart.Version.name || '';

                console.log("this.part_type :" + this.part_type);

                if (this.brand != '' && this.brand != null) {
                    this.selectedBrand = newPart.Brand
                    this.brand = newPart.Brand.name;
                    this.listFilterBrand = [];
                } else {
                    this.selectedBrand = null;
                    this.listFilterBrand = [];
                    this.brand = "";
                }
                if (this.model != '' && this.model != null) {
                    this.selectedModel = newPart.Model;
                    this.model = newPart.Model.name;
                    this.listFilterModel = [];

                } else {
                    this.selectedModel = null;
                    this.listFilterModel = [];
                    this.model = "";
                }
                if (this.generation != '' && this.generation != null) {
                    this.selectedGeneration = newPart.Generation;
                    this.generation = newPart.Generation.name;
                    this.listFilterGeneration = [];

                } else {
                    this.selectedGeneration = null;
                    this.listFilterGeneration = [];
                    this.generation = "";

                }
                if (this.version != '' && this.version != null) {
                    this.selectedVersion = newPart.Version;
                    this.version = newPart.Version.name;
                    this.listFilterVersion = [];
                } else {
                    this.selectedVersion = null;
                    this.listFilterVersion = [];
                    this.version = "";
                }


            },
        }
    };
</script>

<style scoped>
    /* Margin between containers */
    .ba-card, .ba-table {
        margin-top: 2rem;
    }  /* header & card */
    .checkbox-container {
        margin-top: 1.5rem;   /* textarea & checkboxes */
        margin-bottom: 2rem;  /* checkboxes & bar */
    }

    .piece-details .ba-textarea {
        margin: 0 1rem;
    }

    .checkbox-margin {
        margin: 0 5rem;
    }

    /* Tab style */
    .imgZoom {
        position: relative;
    }
    #carousel_0 {
        display: block !important;
    }
    /* Bars */
    .bar {
        position: relative;
        display: block;
    }
    .bar:before, .bar:after {
        position: absolute;
        background: rgb(196, 196, 196);
        content: '';
        height: 1px;
        width: 45%;
        bottom: 0px;
    }
    .bar:before {
        left: 50%;
    }
    .bar:after {
        right: 50%;
    }
    .img-ctn {
        height: 260px;
        padding-right: 20px;
    }
    .img-ctnmodal {
/*        height: 400px;
        width: auto;*/
max-height: 500px;
    }
    .img-ctn:last-of-type {
        padding-right: 0px;
    }
    .carousel-img {
        width: 100%;
        height: 100%;
        max-height:500px;
        object-fit: contain;
    }
    .carousel_loupe {
        cursor: -webkit-zoom-in;
        cursor: zoom-in;
    }
</style>
<style>
    /* Carousel */
    /*  Center Carousel */
    .carousel-container {
        width: 75%;
        margin: 0rem auto 0;
        padding-bottom: 1rem;
        text-align: center;
    }
    .carousel-container2 {
        width: 78% !important;
        margin-top: 22px;
    }
    .carousel-center .tns-inner {
        display: flex;
        justify-content: space-around;
        transform: none;
    }

    /*  Image / slide */
    #app .carousel-container img {
        /*  display: inline-block;
          object-fit: contain;
          width: 40%;*/
    }

    /*  Navigation buttons */
    .piece-details .carousel-container {
        position: relative;
    }
    .piece-details .custom-pagination .prevm,
    .piece-details .custom-pagination .nextm,
    .piece-details .custom-pagination .prev,
    .piece-details .custom-pagination .next {
        position: absolute;
        top: 50%;
        margin-top: -32px;
        width: 64px;
        height: 64px;
        color: var(--app-white-color);
        background-color: var(--app-primary-color);
        border: none;
        border-radius: 50%;
        box-shadow: 1px 4px 4px rgba(0, 0, 0, 0.25);
        cursor: pointer;
    }
    .piece-details .custom-pagination .ab-icon {
        width: 40px;
        height: 40px;
    }
    .piece-details .custom-pagination .prevm {
        left: -64px;
    }
    .piece-details .custom-pagination .nextm {
        right: -64px;
    }
    .piece-details .custom-pagination .prev {
        left: -64px;
    }
    .piece-details .custom-pagination .next {
        right: -64px;
    }
    .piece-details .custom-pagination div:focus {
        outline: none;
    }
    .custom-paginationm {
        display: block!important;
    }
    .div-accessrestreint {
        padding-top: 2px;
        padding-bottom: 22px;
    }

    .dropdown-part {
        background-color:var(--app-input-dropdown-bg-color, rgb(255, 255, 255));
        position:absolute;
        z-index:10;
        box-shadow:var(--ba-input-box-shadow, 0 1px 1px rgba(0,0,0,0.2));
        border-radius:0 0 5px 5px;

    }

    .dropdown-part-u {
        list-style: none;
        font-size: 1rem;
        margin:0;
        padding:1rem 0;
        width:100%;
        max-height:20rem;
        overflow-y:auto;
    }

    .dropdown-part-li {
        display:block;
        color:var(--ba-input-dropdown-element-color, rgb(92, 92, 92));
        font-weight:normal;
        padding-left:10px;
        cursor:pointer;
    }

    .dropdown-part-li:hover {
        background-color:rgb(92, 92, 92);
        color:white;
    }


</style>
<style src="@/assets/styles/tabs.css"></style>
<style src="@/assets/styles/datepickers.css"></style>
<style src="@/assets/styles/modals.css"></style>
<style src="@/assets/styles/filepond.css"></style>
